<ssc-app-layout [showFooterContactButton]="true" containerSize="small">
  <ssc-header [hasBasket]="false" [hasStepper]="true"></ssc-header>

  <h1 class="headline-1">{{ 'KEY_DATA.TITLE' | translate }}</h1>

  <div class="campaign-info-box">
    <dap-lib-info-box
      *ngIf="(hasFrameworkContract$ | async) && (isTupCustomer$ | async) === false"
      iconName="discount-thin"
      [description]="'KEY_DATA.FRAMEWORK_CONTRACT_INFO_TEXT' | translate"
      infoType="info"
    ></dap-lib-info-box>
  </div>

  <form class="form" [formGroup]="formGroup" [dapLibScrollToError]="scrollToErrorEventEmitter">
    <ng-container formArrayName="persons">
      <ng-container
        *ngFor="let personForm of formGroup.controls.persons.controls; index as index; count as amountOfPersons"
      >
        <ssc-person-data
          (remove)="removePerson(index, personForm)"
          [index]="index"
          [showHeader]="amountOfPersons > 1"
          [showNameField]="amountOfPersons > 1"
          [personFormGroup]="personForm"
          [validateForm]="showValidations"
          [scrollIntoView]="false"
        ></ssc-person-data>

        <ng-container *ngIf="index === 0">
          <ssc-zip-code-autocomplete
            [formControl]="formGroup.controls.address"
            [validateForm]="showValidations"
            [saleOfferBegin]="formGroup.controls.saleOfferBegin"
          ></ssc-zip-code-autocomplete>
        </ng-container>
      </ng-container>
    </ng-container>
  </form>
  <div class="action-container" [ngClass]="{ 'single-button': (isTupCustomer$ | async) }">
    <dap-lib-button
      *ngIf="(isTupCustomer$ | async) === false"
      class="stretch"
      (click)="addPerson()"
      [variant]="'tertiary'"
      [buttonSize]="'large'"
      iconPosition="left"
      iconName="add"
      data-cy="button-add-persons"
      data-analytics="key-data_add-person"
      >{{ 'KEY_DATA.NAVIGATION.ADD_PERSON' | translate }}</dap-lib-button
    >
    <dap-lib-button
      class="stretch"
      (click)="tryUpdateStoreAndNavigate()"
      [variant]="'primary'"
      [buttonSize]="'large'"
      data-cy="button-show-prices"
      data-analytics="key-data_navigate-to-products"
      >{{ 'KEY_DATA.NAVIGATION.SHOW_PRICES' | translate }}</dap-lib-button
    >
  </div>
</ssc-app-layout>
<dap-lib-popup
  [isOpen]="showPopupType !== undefined"
  title="{{ 'KEY_DATA.OFFER_CHANGE.TITLE' | translate }}"
  (cancel)="closePopup()"
  data-cy="offer-change-popup"
>
  <ng-container ngProjectAs="content">
    <p *ngIf="showPopupType === 'BFS_OR_SALE_OFFER_BEGIN_CHANGED'">
      {{ 'KEY_DATA.OFFER_CHANGE.BFS_OR_SALE_OFFER_BEGIN.TEXT' | translate }}
    </p>
    <p *ngIf="showPopupType === 'DATE_OF_BIRTH_OR_GENDER_CHANGED'">
      {{ 'KEY_DATA.OFFER_CHANGE.GENDER_OR_DATE_OF_BIRTH.TEXT' | translate }}
    </p>
  </ng-container>
  <ng-container ngProjectAs="footer">
    <dap-lib-button
      (click)="closePopup()"
      buttonSize="medium"
      variant="secondary"
      class="stretch"
      data-analytics="key-data-popup_dont-remove-offer"
      >{{ 'KEY_DATA.OFFER_CHANGE.CANCEL' | translate }}</dap-lib-button
    >
    <dap-lib-button
      (click)="updateStoreAndNavigate()"
      buttonSize="medium"
      variant="primary"
      class="stretch"
      data-cy="remove-offer"
      data-analytics="key-data-popup_remove-offer"
      >{{ 'KEY_DATA.OFFER_CHANGE.MAKE_CHANGE' | translate }}</dap-lib-button
    >
  </ng-container>
</dap-lib-popup>
